class AccountPagination {
	constructor() {
		this.init();
	}

	init() {
        $("body").on( "click", ".account-items-wrapper a.page-numbers", function(e) {
            e.preventDefault();
            const wrapper = $(this).parents(".account-items-wrapper:first");
            
            if(wrapper.hasClass('working')){
                return;
            }

            wrapper.addClass('working');

            const page = $(this).attr("href").split('/').pop();
            const data_type = wrapper.attr('data-type');
            const data_subtype = wrapper.attr('data-subtype');
            const wrapper_id = wrapper.attr('id');

            $.ajax({
                type: "POST",
                url: tdI18n.ajaxurl,
                data: {
                    'page' : page,
                    'data_type' : data_type,
                    'data_subtype' : data_subtype,
                    'action' : 'my_account/items'
                },
                success: function (result) {
                    $('#' + wrapper_id).html(result.html);
                    wrapper.removeClass('working');
                },
                error: function (data) {
                    console.log(data);
                    wrapper.removeClass('working');
                },
            });

        })
	}
}
export default AccountPagination;
